/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import CheckmarkOutline20 from '@carbon/icons-react/es/checkmark--outline/20';
import { Editor } from '@ckeditor/ckeditor5-core/src/editor/editor';
import React, { FC } from 'react';
import { IconWrapper } from 'components/atoms/icon-shell/icon-shell';
import { useTranslation } from 'hooks/use-translation';
import { INSERT_DOC_TASK_SECTION_COMMAND } from 'vendor/ckeditor/plugins/document-tasks-section';
import { StyledToolItem } from '../styled-components';
import styles from './task-section-tool.module.css';

interface Props {
  editor: Editor;
}

export const TaskSectionToolHandler: FC<Props> = ({ editor }) => {
  const handleClick = () => {
    const options = {
      resourceSectionId: Number(new Date()),
    };

    editor?.execute(INSERT_DOC_TASK_SECTION_COMMAND, options);
  };

  return (
    <div onClick={handleClick} className={styles.tool}>
      <StyledToolItem>
        <IconWrapper>
          <CheckmarkOutline20 />
        </IconWrapper>
        {useTranslation('toolbar.add_task_section')}
      </StyledToolItem>
    </div>
  );
};
